import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { ClipboardService } from 'ngx-clipboard';

import { ApisService } from '../../services/apis.service';
import { HermesService } from '../../services/hermes.service';
import { ElectronService } from '../../services/electron.service';

import { JockeyWeightInComponent } from '../jockey-weight-in/jockey-weight-in.component';
import { JockeyWeightRuleBreachComponent } from '../jockey-weight-rule-breach/jockey-weight-rule-breach.component';
import { JockeyWeightOutComponent } from '../jockey-weight-out/jockey-weight-out.component';
import { JockeyGearChecksComponent } from '../jockey-gear-checks/jockey-gear-checks.component';
import { JockeyClaimComponent } from '../jockey-claim/jockey-claim.component';
import { JockeyWeightPenaltyComponent } from '../jockey-weight-penalty/jockey-weight-penalty.component';
import { JockeyCommentsComponent } from '../jockey-comments/jockey-comments.component';
import { RaceAuctionClaimComponent } from '../race-auction-claim/race-auction-claim.component';
import { JockeyChangeComponent } from '../jockey-change/jockey-change.component';
import { JockeyDisqualifyComponent } from '../jockey-disqualify/jockey-disqualify.component';
import { RaceWithdrawnComponent } from '../race-withdrawn/race-withdrawn.component';
import { RaceCommentsComponent } from '../race-comments/race-comments.component';
import { RaceConfirmWeighInComponent } from '../race-confirm-weigh-in/race-confirm-weigh-in.component';
import { RaceConditionsComponent } from '../race-conditions/race-conditions.component';
import { AmendPositionComponent } from '../amend-position/amend-position.component';
import { ConfirmActionComponent } from '../confirm-action/confirm-action.component';
import { DomSanitizer } from '@angular/platform-browser';
import { SilkService } from '../../services/silk.service';
import { JockeyRoomLeaveComponent } from "../jockey-room-leave/jockey-room-leave.component";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private apiService: ApisService,
    private hermes: HermesService,
    private notification: ToastrService,
    private clipboardService: ClipboardService,
    private sanitizer: DomSanitizer,
    protected silkService: SilkService
  ) {}

  testModel: any;
  userId: number;
  hermesConnection: any;
  selectedJockey: any;
  selectedDate: {
    year: number;
    month: number;
    day: number;
  };
  meta: {
    debugMode: boolean;
    loadingData: boolean;
    savingData: boolean;
    detailsOpen: boolean;
    modalOpen: boolean;
    weighInfoCollapsed: boolean;
    debugInfoCopied: boolean;
    minDate: any;
    maxDate: any;
  };
  list: {
    fixtures: any[];
    races: any[];
    nonRunnerReasons: any[];
  };
  selected: {
    fixtureIndex: number;
    raceIndex: number;
    jockeyIndex: number;
    updatedBy: number;
  };

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    if (event.code === 'Escape' && this.meta.detailsOpen && !this.meta.modalOpen) {
      this.toggleSidebar('close');
    }
  }

  ngOnInit() {
    this.meta = {
      debugMode: false,
      loadingData: false,
      savingData: false,
      detailsOpen: false,
      modalOpen: false,
      weighInfoCollapsed: true,
      debugInfoCopied: false,
      minDate: moment('2018-11-19').toDate(),
      maxDate: moment()
        .add(2, 'days')
        .toDate()
    };

    this.list = {
      fixtures: [],
      races: [],
      nonRunnerReasons: []
    };

    this.selected = {
      fixtureIndex: null,
      raceIndex: null,
      jockeyIndex: null,
      updatedBy: null
    };

    this.route.queryParams.subscribe(queryParams => {
      this.apiService.changeDebugMode(queryParams.debug !== undefined);
    });

    this.apiService.observableDebugMode.subscribe(data => {
      this.meta.debugMode = data;
      if (this.meta.debugMode) {
        this.meta.minDate = null;
        this.meta.maxDate = null;
      }
    });

    this.apiService.observableFixture.subscribe(data => {
      this.toggleSidebar('close');
      this.list.fixtures.map(f => (f.selected = false));
      this.selected = {
        fixtureIndex: data.index,
        raceIndex: null,
        jockeyIndex: null,
        updatedBy: null
      };
      if (this.hermesConnection && this.selected.fixtureIndex === null) {
        this.hermesConnection.unsubscribe();
        this.hermesConnection = null;
      }
    });

    this.apiService.observableLoggedIn.subscribe(data => {
      this.userId = data.user_id;
    });

    const today = moment();
    this.selectedDate = {
      year: today.year(),
      month: today.month() + 1,
      day: today.date()
    };

    this.getNonRunnerReasons();
    this.getFixtures(this.selectedDate);

    // if (this.electron.isElectron()) {
    //   this.electron.getUsbDevices().then((usbDevices) => {
    //     console.log('[ DEBUG ] USB Devices:', usbDevices);
    //   });
    //   this.electron.getSerialPorts().then((serialPorts) => {
    //     console.log('[ DEBUG ] Serial Ports:', serialPorts);
    //   });
    // }
  }

  // Force datepicker to close if click outside of it
  datepickerFix = (event, datePicker) => {
    if (event.target.offsetParent == null) {
      datePicker.close();
    } else if (event.target.offsetParent.nodeName !== 'NGB-DATEPICKER') {
      datePicker.close();
    }
  }

  toggleSidebar(action: string) {
    switch (action) {
      case 'open':
        this.meta.detailsOpen = true;
        break;
      case 'close':
        this.meta.detailsOpen = false;
        this.meta.weighInfoCollapsed = true;
        if (this.selected.raceIndex && this.selected.jockeyIndex) {
          this.selectJockey(null);
        }
        break;
    }
  }

  getNonRunnerReasons() {
    this.apiService.getNonRunnerReasons().subscribe(
      res => {
        this.list.nonRunnerReasons = res;
        // console.log(this.list.nonRunnerReasons);
      },
      err => {
        console.error('[ DEBUG ] Error loading non runner reasons', err);
        this.notification.error(`Could't get the Non Runner Reasons list. Check your connection and Try again.`,
          'Non Runners', { disableTimeOut: true }
        );
      }
    );
  }

  getFixtures(date) {
    this.meta.loadingData = true;
    const requestDate = Object.assign({}, date);
    requestDate.month -= 1;

    this.list.races = [];
    this.list.fixtures = [];
    this.apiService.getFixtures(moment(requestDate).format('YYYYMMDD')).subscribe(
      res => {
        this.list.fixtures = res.data;
        this.processFixtures();
      },
      err => {
        console.error('Error getting Fixtures', err);
        this.notification.error(`Couldn't receive the list of Fixture. Check your connection and retry.`,
          'Fixtures', { disableTimeOut: true }
        );
      },
      () => {
        console.log('[ DEBUG ] Fixtures:', this.list.fixtures);
        this.meta.loadingData = false;
        this.selected.fixtureIndex = null;
        this.selected.raceIndex = null;
        this.selected.jockeyIndex = null;
        this.selectedJockey = null;
      }
    );
  }

  processFixtures() {
    this.list.fixtures.forEach((fixture, i) => {
      this.list.fixtures[i].abandoned = fixture.abandonedStageCode !== 4 && fixture.abandonedStageCode !== 0;
      if (fixture.conditions.ground) {
        this.list.fixtures[i].going = this.apiService.getGroundDescription(fixture.conditions.ground).label;
        if (fixture.conditions.conditionInPlaces) {
          this.list.fixtures[i].going += `, ${this.apiService.getGroundDescription(fixture.conditions.conditionInPlaces).label} in places`;
        }
        if (fixture.conditions.groundUpdatedAt) {
          this.list.fixtures[i].going += ` on ${moment(fixture.conditions.groundUpdatedAt).format('Do MMM, h:mm A')}`;
        }
      }
      if (fixture.conditions.goingStickAvailable) {
        this.list.fixtures[i].stick = `${fixture.conditions.goingStick}
           on ${moment(fixture.conditions.goingStickUpdatedAt).format('Do MMM, h:mm A')}`;
      }
    });
  }

  selectFixture(index: number = 0) {
    this.toggleSidebar('close');
    if (this.list.fixtures[index]) {
      this.meta.loadingData = true;
      this.list.races = [];
      this.selected.fixtureIndex = index;
      this.list.fixtures.map(f => (f.selected = false));
      this.list.fixtures[index].selected = true;
      if (!this.list.fixtures[index].abandoned) {
        this.getRaces(this.list.fixtures[index].fixtureYear, this.list.fixtures[index].fixtureId);
      } else {
        this.meta.loadingData = false;
      }
    } else {
      this.selectFixture(0);
    }
    const fixtureToUpdate = this.list.fixtures[this.selected.fixtureIndex];
    this.apiService.changeFixtureData({
      index: this.selected.fixtureIndex,
      courseName: fixtureToUpdate.courseName,
      fixtureDate: fixtureToUpdate.fixtureDate
    });
    console.log('[ DEBUG ] Fixture Selected:', this.selected);
  }

  getRaces(year: number, fixtureId: number) {
    this.meta.loadingData = true;
    this.apiService.getRaces(year, fixtureId).subscribe(
      res => {
        this.list.races = res;
        this.list.races.forEach((race, i) => {
          this.list.races[i].weightInComplete = this.weightInComplete(this.list.races[i]);
          this.list.races[i].weightOutComplete = this.weightOutComplete(this.list.races[i]);
          this.list.races[i].statuses = {
            'weighedOutTime': race.weighedOutTime,
            'jockeysOutTime': race.jockeysOutTime,
            'stewardsSecretaryTime': race.stewardsSecretaryTime,
            'stewardsEnquiryTime': race.stewardsEnquiryTime,
            'resultStandsTime': race.resultStandsTime,
            'resultAmendedTime': race.resultAmendedTime,
            'horsesAwayTime': race.horsesAwayTime,
            'weighedInTime': race.weighedInTime,
            'stewardsNoticeTime': race.stewardsNoticeTime,
          };

          // Modded for COVID
          race.runners.forEach(async (jockey, j) => {
            this.list.races[i].runners[j].covidModLbs = 3;
            this.list.races[i].runners[j].userMark = false;
            this.list.races[i].runners[j].jockeyName = jockey.jockeyName !== 'Non Runner' ? jockey.jockeyName : jockey.jockeyAtDec;
            this.list.races[i].runners[j].weights['O'] = jockey.weights['O'] ? jockey.weights['O'] : {};
            this.list.races[i].runners[j].weights['I'] = jockey.weights['I'] ? jockey.weights['I'] : {};
            this.list.races[i].runners[j].weightInReady = this.weightInReady(this.list.races[i]);
            this.list.races[i].runners[j].sponsors = {
              jockey: jockey.sponsors.filter(js => js.sponsorType === 'J').map(js => js.sponsor),
              owner: jockey.sponsors.filter(os => os.sponsorType === 'O').map(os => os.sponsor)
            };

            this.list.races[i].runners[j].silkImageBase64 = await this.getSilkImage(this.list.races[i].runners[j]);

            this.list.races[i].runners[j].gearChecksStatus = this.updateGearCheckStatus(this.list.races[i].runners[j].headGears);
            this.list.races[i].runners[j].requireGearCheck = !!this.list.races[i].runners[j].headGears.filter(gc => gc.code !== 'T').length;

            this.list.races[i].runners[j].jockeyChangedFrom = this.getLatestJockeyChange(this.list.races[i].runners[j]);

            if (jockey.nonRunnerCode) {
              this.list.races[i].runners[j].nonRunnerReason = this.list.nonRunnerReasons
                .find(nrr => Number(nrr.listCode) === jockey.nonRunnerCode).description;
            }
            if (jockey.disqualifiedCode) {
              const disqualifiedReasons = this.apiService.getDisqualifiedReasons();
              this.list.races[i].runners[j].disqualifiedReason = disqualifiedReasons.find(d => d.id === jockey.disqualifiedCode).label;
            }
            if (jockey.position && jockey.position >= 1 && jockey.position <= 4) {
              jockey.requiredWeightIn = true;
            } else {
              jockey.requiredWeightIn = false;
            }
            if (jockey.nonFinishingCode) {
              this.list.races[i].runners[j].nonFinishingDescription = this.apiService
                .getFinishingCodes()
                .find(nf => nf.id === this.list.races[i].runners[j].nonFinishingCode).label;
            }

            const courses = Array.from(new Set(jockey.bookings.map(b => b.courseName)));
            if (courses.length) {
              this.list.races[i].runners[j].aggregatedBookings = {};
              courses.forEach(course => {
                this.list.races[i].runners[j].aggregatedBookings[String(course)] = this.list.races[i].runners[j].bookings
                  .filter(b => b.courseName === String(course))
                  .map(b => moment(b.raceDateTime).format('h:mm a'));
              });
              this.list.races[i].runners[j].bookings = Object.keys(this.list.races[i].runners[j].aggregatedBookings).length > 1
                ? true : false;
            } else {
              this.list.races[i].runners[j].aggregatedBookings = null;
              this.list.races[i].runners[j].bookings = 0;
            }
            this.list.races[i].runners[j].claims.forEach((claim, k) => {
              this.list.races[i].runners[j].claims[k].value = Number(this.list.races[i].runners[j].claims[k].value);
            });
          });
        });
      },
      err => {
        console.error('[ DEBUG ] Error getting Races', err);
        this.notification.error(`Couldn't receive the list of races. Check your connection and retry.`, 'Races', { disableTimeOut: true });
      },
      () => {
        console.log('[ DEBUG ] Races:', this.list.races);
        this.meta.loadingData = false;
        this.selected.raceIndex = null;
        this.selected.jockeyIndex = null;
        this.selectedJockey = null;
        this.selectRace({ activeId: 'tab-0', nextId: 'tab-0', preventDefault: () => {} });

        // Start listening for Hermes
        if (!this.hermesConnection) {
          this.startListener();
        }
      }
    );
  }

  getSilkImage(runner) {
    return new Promise((resolve, reject) => {
      this.apiService.getSilk(runner.entryColourDescription, runner.entryColourCode, !!runner.nonRunnerCode).subscribe(
        res => resolve('data:image/svg+xml;base64,' + res.svg),
        err => {
          console.log('[ DEBUG ] Error loading Silk', err);
          resolve(null);
        }
      );
    });
  }

  sanitize(url) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  getLatestJockeyChange(jockey) {
    if (jockey.jockeyId !== null) {
      if (jockey.jockeyChanges && jockey.jockeyChanges.length) {
        return {
          jockeyName: jockey.jockeyChanges[jockey.jockeyChanges.length - 1].jockeyName,
          changedAt: jockey.jockeyChanges[jockey.jockeyChanges.length - 1].changedAt,
          toUnregistered: false
        };
      }
    }
    if (jockey.jockeyId === null) {
      if (jockey.jockeyChanges && jockey.jockeyChanges.length) {
        return {
          jockeyName: jockey.jockeyChanges[jockey.jockeyChanges.length - 1].jockeyName,
          changedAt: null,
          toUnregistered: true
        };
      } else {
        return {
          jockeyName: jockey.declaredJockeyName,
          changedAt: null,
          toUnregistered: true
        };
      }
    }
  }

  selectRace(tabChange: NgbTabChangeEvent) {
    this.toggleSidebar('close');
    const index = tabChange.nextId.split('-')[1];
    if (this.list.races[index]) {
      if (this.selected.raceIndex !== null) {
        this.list.races[this.selected.raceIndex].runners.map(r => (r.selected = false));
      }
      this.selected.raceIndex = Number(index);
      this.selected.jockeyIndex = null;
      this.selectedJockey = null;
      console.log('[ DEBUG ] Race Selected:', this.selected);
    }
  }

  selectJockey(index: null | number) {
    if (index === null) {
      this.list.races[this.selected.raceIndex].runners.forEach(r => (r.selected = false));
      this.selected.jockeyIndex = null;
      this.selectedJockey = null;
    } else {
      this.selected.jockeyIndex = index;
      this.meta.weighInfoCollapsed = true;
      if (this.list.races[this.selected.raceIndex].runners[this.selected.jockeyIndex]) {
        this.list.races[this.selected.raceIndex].runners.forEach(r => (r.selected = false));
        this.list.races[this.selected.raceIndex].runners[this.selected.jockeyIndex].selected = true;
        this.selectedJockey = this.list.races[this.selected.raceIndex].runners[this.selected.jockeyIndex];
        this.selectedJockey.weightInReady = this.weightInReady(this.list.races[this.selected.raceIndex]);
        console.log(`[ DEBUG ] Selected Entry ${this.selectedJockey.animalId}, ` +
          ` ${this.selectedJockey.animalName}, ${this.selectedJockey.jockeyName}`, this.selectedJockey
        );
        console.log('[ DEBUG ] Jockey Selected:', this.selected);
        this.toggleSidebar('open');
      }
    }
  }

  addUserMark() {
    this.selectedJockey.userMark = !this.selectedJockey.userMark;
  }

  addRequireWeighIn(event, jockeyIndex) {
    if (jockeyIndex === 'all') {
      this.list.races[this.selected.raceIndex].runners
        .filter(r => !r.nonRunnerCode && !r.withdrawnTimestamp)
        .forEach(r => {
          r.requiredWeightIn = true;
        });
    } else {
      this.list.races[this.selected.raceIndex].runners[jockeyIndex].requiredWeightIn =
        !this.list.races[this.selected.raceIndex].runners[jockeyIndex].requiredWeightIn;
      event.stopPropagation();
    }
  }

  openJockeyChange() {
    const modalWindow = this.modalService.open(JockeyChangeComponent,
      { centered: true, backdrop: 'static', windowClass: 'modal-left-centered' });
    this.meta.modalOpen = true;
    modalWindow.componentInstance.jockey = this.selectedJockey;
    modalWindow.result.then(
      result => {
        this.meta.modalOpen = false;
        console.log('[ DEBUG ] Modal returned value:', result);
        this.selectedJockey.jockeyId = result.jockeyId;
        this.selectedJockey.jockeyName = result.jockeyName;
        this.selectedJockey.jockeyClaim = result.jockeyClaim;
        this.selectedJockey.jockeyType = result.jockeyType;
        this.selectedJockey.jockeyChanges = result.jockeyChanges;
        this.selectedJockey.jockeyChangedFrom = this.getLatestJockeyChange(this.selectedJockey);
        this.selectedJockey.nextOfKin = result.nextOfKin;
        this.selectedJockey.nextOfKinPhone = result.nextOfKinPhone;
        if (result.resetWeighOut) {
          this.selectedJockey.weights['O'] = {};
        }
      },
      reason => {
        this.meta.modalOpen = false;
        // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
      }
    );
  }

  openClaim() {
    const modalWindow = this.modalService.open(JockeyClaimComponent,
      { centered: true, backdrop: 'static', windowClass: 'modal-left-centered' }
    );
    this.meta.modalOpen = true;
    modalWindow.componentInstance.jockey = this.selectedJockey;
    modalWindow.result.then(
      result => {
        this.meta.modalOpen = false;
        // console.log('[ DEBUG ] Modal returned value:', result);
        this.selectedJockey.jockeyClaim = result.jockeyClaim;
        if (result.resetWeighOut) {
          this.selectedJockey.weights['O'] = {};
        }
      },
      reason => {
        this.meta.modalOpen = false;
        // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
      }
    );
  }

  openPenalty() {
    const modalWindow = this.modalService.open(JockeyWeightPenaltyComponent,
      { centered: true, backdrop: 'static', windowClass: 'modal-left-centered' }
    );
    this.meta.modalOpen = true;
    modalWindow.componentInstance.jockey = this.selectedJockey;
    modalWindow.result.then(
      result => {
        this.meta.modalOpen = false;
        // console.log('[ DEBUG ] Modal returned value:', result);
        this.selectedJockey.penaltyWeight  = result.penaltyWeight;
        if (result.resetWeighOut) {
          this.selectedJockey.weights['O'] = {};
        }
      },
      reason => {
        this.meta.modalOpen = false;
        // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
      }
    );
  }

  openWeightOut() {
    const raceToUpdate = this.list.races[this.selected.raceIndex];
    const modalWindow = this.modalService.open(JockeyWeightOutComponent,
      { centered: true, backdrop: 'static', windowClass: 'modal-left-centered' }
    );
    this.meta.modalOpen = true;
    modalWindow.componentInstance.jockey = this.selectedJockey;
    modalWindow.result.then(
      result => {
        this.meta.modalOpen = false;
        // console.log('[ DEBUG ] Modal returned value:', result);
        this.selectedJockey.weights['O'].weightRecorded = result.weightRecorded;
        this.selectedJockey.weights['O'].weightDisplayed = result.weightDisplayed;
        this.selectedJockey.weights['O'].jockeyOverweight = result.jockeyOverweight;
        this.selectedJockey.weights['O'].type = result.type;
        this.selectedJockey.weights['O'].modifiedTimestamp = result.modifiedTimestamp;
        this.selectedJockey.weightInReady = this.weightInReady(raceToUpdate);
        this.toggleSidebar('close');
      },
      reason => {
        this.meta.modalOpen = false;
        // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
      }
    );
  }

  openWeightIn() {
    const raceToUpdate = this.list.races[this.selected.raceIndex];
    const modalWindow = this.modalService.open(JockeyWeightInComponent,
      { centered: true, backdrop: 'static', windowClass: 'modal-left-centered' }
    );
    this.meta.modalOpen = true;
    modalWindow.componentInstance.jockey = this.selectedJockey;
    modalWindow.result.then(
      result => {
        this.meta.modalOpen = false;
        // console.log('[ DEBUG ] Modal returned value:', result);
        this.selectedJockey.weights['I'].weightRecorded = result.weightRecorded;
        this.selectedJockey.weights['I'].weightDisplayed = result.weightDisplayed;
        this.selectedJockey.weights['I'].modifiedTimestamp = result.modifiedTimestamp;
        this.selectedJockey.weights['I'].type = result.type;
        this.selectedJockey.weights['I'].ruleBreach = result.ruleBreach;
        if (result.triggerRuleBreach) {
          this.openRuleBreach();
        }
        raceToUpdate.weightOutComplete = this.weightOutComplete(raceToUpdate);
        raceToUpdate.weightInComplete = this.weightInComplete(raceToUpdate);
        this.toggleSidebar('close');
      },
      reason => {
        this.meta.modalOpen = false;
        // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
      }
    );
  }

  openGearChecks() {
    const modalWindow = this.modalService.open(JockeyGearChecksComponent,
      { centered: true, backdrop: 'static', windowClass: 'modal-left-centered' });
    this.meta.modalOpen = true;
    modalWindow.componentInstance.jockey = this.selectedJockey;
    modalWindow.componentInstance.race = this.list.races[this.selected.raceIndex];
    modalWindow.result.then(
      result => {
        // console.log('Modal returned', result);
        this.meta.modalOpen = false;
        this.selectedJockey.headGears = result.headGears;
        this.selectedJockey.gearChecksStatus = this.updateGearCheckStatus(result.headGears);
      },
      reason => {
        this.meta.modalOpen = false;
        // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
      }
    );
  }

  openRuleBreach() {
    const raceToUpdate = this.list.races[this.selected.raceIndex];
    const modalWindow = this.modalService.open(JockeyWeightRuleBreachComponent,
      { centered: true, backdrop: 'static', windowClass: 'modal-left-centered' }
    );
    this.meta.modalOpen = true;
    modalWindow.componentInstance.jockey = this.selectedJockey;
    modalWindow.result.then(
      result => {
        this.meta.modalOpen = false;
        // console.log('[ DEBUG ] Modal returned value:', result);
        this.selectedJockey.weights['I'].ruleBreach = result.ruleBreach;
      },
      reason => {
        this.meta.modalOpen = false;
        // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
      }
    );
  }

  openComments() {
    const modalWindow = this.modalService.open(JockeyCommentsComponent,
      { centered: true, backdrop: 'static', windowClass: 'modal-left-centered' }
    );
    this.meta.modalOpen = true;
    modalWindow.componentInstance.jockey = this.selectedJockey;
    modalWindow.result.then(
      result => {
        this.meta.modalOpen = false;
        // console.log('[ DEBUG ] Modal returned value:', result);
        const updatedIndex = this.selectedJockey.comments.findIndex(c => c.textCode === result.textCode);
        if (updatedIndex !== -1) {
          this.selectedJockey.comments[updatedIndex] = {
            textCode: result.textCode,
            comment: result.comment
          };
        } else {
          this.selectedJockey.comments.push({
            textCode: result.textCode,
            comment: result.comment
          });
        }
      },
      reason => {
        this.meta.modalOpen = false;
        // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
      }
    );
  }

  openWithdrawn() {
    if (this.selectedJockey.position) {
      const initialModal = this.modalService.open(ConfirmActionComponent, {
        backdrop: 'static',
      });

      this.meta.modalOpen = true;
      initialModal.componentInstance.body = `
        <p>You are confirming <strong>Post Result Withdrawn</strong> whilst this entry has a position. This Action cannot be reversed as it sends data directly to the Press Association.</p>
        <p>Please confirm that you want to proceed.</p>`;

      initialModal.result.then(
        result => {
          this.meta.modalOpen = false;
          // If the first modal is accepted, open the next one
          const modalWindow = this.modalService.open(RaceWithdrawnComponent, {
            centered: true,
            backdrop: 'static',
            windowClass: 'modal-left-centered'
          });
          this.meta.modalOpen = true;
          modalWindow.componentInstance.runner = this.selectedJockey;
          modalWindow.componentInstance.isWithdrawnPostResult = true;
          modalWindow.result.then(
            result => {
              this.meta.modalOpen = false;
              this.selectedJockey.withdrawnTimestamp = result.withdrawnTimestamp;
              this.selectedJockey.withdrawnPostResult = result.withdrawnPostResult;
              this.selectedJockey.withdrawnFeePaid = result.withdrawnFeePaid;
            },
            reason => {
              this.meta.modalOpen = false;
              // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
            }
          );
        },
        reason => {
          this.meta.modalOpen = false;
          // console.log(`[ DEBUG ] First modal dismissed: ${reason}`);
        }
      );
    } else {
      const modalWindow = this.modalService.open(RaceWithdrawnComponent, {
        centered: true,
        backdrop: 'static',
        windowClass: 'modal-left-centered'
      });
      this.meta.modalOpen = true;
      modalWindow.componentInstance.runner = this.selectedJockey;
      modalWindow.result.then(
        result => {
          this.meta.modalOpen = false;
          this.selectedJockey.withdrawnTimestamp = result.withdrawnTimestamp;
          this.selectedJockey.withdrawnFeePaid = result.withdrawnFeePaid;
        },
        reason => {
          this.meta.modalOpen = false;
          // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
        }
      );
    }
  }

  setNonRunner() {
    if (this.selectedJockey.nonRunnerCode === null) {
      this.selectedJockey.nonRunnerCode = 'user-request';
      this.selectedJockey.nonRunnerReason = 'User Request';
      this.selectedJockey.nonRunnerTimestamp = moment().toISOString();
    } else if (this.selectedJockey.nonRunnerCode === 'user-request') {
      this.selectedJockey.nonRunnerCode = null;
      this.selectedJockey.nonRunnerReason = null;
      this.selectedJockey.nonRunnerTimestamp = null;
    }
    this.toggleSidebar('close');
  }

  openDisqualify() {
    const modalWindow = this.modalService.open(JockeyDisqualifyComponent,
      { centered: true, backdrop: 'static', windowClass: 'modal-left-centered' }
    );
    this.meta.modalOpen = true;
    modalWindow.componentInstance.runner = this.selectedJockey;
    modalWindow.result.then(
      result => {
        this.meta.modalOpen = false;
        // console.log('[ DEBUG ] Modal returned value:', result);
        this.selectedJockey.disqualifiedCode = result.disqualifiedCode;
        this.selectedJockey.disqualifiedTimestamp = result.disqualifiedTimestamp;
        this.selectedJockey.disqualifiedReason = this.apiService.getDisqualifiedReasons().find(d => d.id === result.disqualifiedCode).label;
      },
      reason => {
        this.meta.modalOpen = false;
        // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
      }
    );
  }

  resetDisqualified() {
    this.meta.savingData = true;
    const race = this.list.races[this.selected.raceIndex];
    this.apiService.resetDisqualified(race.yearOfRace, race.raceId, race.divisionSequence).subscribe(
      res => {
        race.runners.forEach(r => {
          r.disqualifiedCode = null;
        });
        this.notification.success(`The disqualifications have been reset.`, 'Disqualifications');
        this.meta.savingData = false;
      },
      err => {
        console.error('[ DEBUG ] Error resetting disqualifications', err);
        this.notification.error(`Could't reset the disqualified entries. Check your connection and Try again.`, 'Disqualifications');
        this.meta.savingData = false;
      }
    );
  }

  openRaceClaim() {
    const modalWindow = this.modalService.open(RaceAuctionClaimComponent,
      { centered: true, backdrop: 'static', windowClass: 'modal-left-centered' }
    );
    this.meta.modalOpen = true;
    modalWindow.componentInstance.jockey = this.selectedJockey;
    modalWindow.result.then(
      result => {
        this.meta.modalOpen = false;
        // console.log('[ DEBUG ] Modal returned value:', result);
        if (result.removeClaim) {
          this.selectedJockey.claims = [];
        } else {
          this.selectedJockey.claims = [result];
        }
      },
      reason => {
        this.meta.modalOpen = false;
        // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
      }
    );
  }

  openAmendPosition() {
    const modalWindow = this.modalService.open(AmendPositionComponent,
      { centered: true, backdrop: 'static', windowClass: 'modal-left-centered' }
    );
    this.meta.modalOpen = true;
    modalWindow.componentInstance.jockey = this.selectedJockey;
    modalWindow.componentInstance.race = this.list.races[this.selected.raceIndex];
    modalWindow.result.then(
      result => {
        this.meta.modalOpen = false;
        // console.log('[ DEBUG ] Modal returned value:', result);
        this.selectedJockey.position = result.position;
      },
      reason => {
        this.meta.modalOpen = false;
        // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
      }
    );
  }

  openRaceComments() {
    const raceToUpdate = this.list.races[this.selected.raceIndex];
    const modalWindow = this.modalService.open(RaceCommentsComponent,
      { centered: true, backdrop: 'static' }
    );
    this.meta.modalOpen = true;
    modalWindow.componentInstance.race = raceToUpdate;
    modalWindow.result.then(
      result => {
        this.meta.modalOpen = false;
        // console.log('[ DEBUG ] Modal returned value:', result);
        raceToUpdate.comment = result.comment;
      },
      reason => {
        this.meta.modalOpen = false;
        // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
      }
    );
  }

  openRaceConditions() {
    const raceToShow = this.list.races[this.selected.raceIndex];
    const FixtureToShow = this.list.fixtures[this.selected.fixtureIndex];
    const modalWindow = this.modalService.open(RaceConditionsComponent, { centered: true, backdrop: 'static', size: 'lg' });
    this.meta.modalOpen = true;
    modalWindow.componentInstance.race = raceToShow;
    modalWindow.componentInstance.fixture = FixtureToShow;
    modalWindow.result.then(
      result => {
        this.meta.modalOpen = false;
        // console.log(`[ DEBUG ] Modal dismissed: ${result}`);
      },
      reason => {
        this.meta.modalOpen = false;
        // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
      }
    );
  }

  async updateStatus(state, event) {
    event.srcElement.blur();
    event.preventDefault();
    console.log(state, 'received');
    if (this.meta.savingData !== true) {
      this.meta.savingData = true;
      const payload = {
        year: this.list.races[this.selected.raceIndex].yearOfRace,
        raceId: this.list.races[this.selected.raceIndex].raceId,
        divSeq: this.list.races[this.selected.raceIndex].divisionSequence,
        updatedBy: this.userId
      };

      let ts = null;
      if (this.list.races[this.selected.raceIndex].statuses[state] === null) {
        ts = moment().format('YYYY-MM-DD HH:mm:ss');
      } else {
        ts = null;
      }

      let abort = false;
      let errorMessage = null;

      if (state === 'stewardsEnquiryTime') {
        if (this.list.races[this.selected.raceIndex].statuses.stewardsSecretaryTime) {
          errorMessage = '"Steward Secretary" already selected';
          abort = true;
        }
        if (this.list.races[this.selected.raceIndex].statuses.stewardsEnquiryTime) {
          errorMessage = '"Steward Enquiry" cannot be reverted';
          abort = true;
        }
      }

      // if (state === 'stewardsSecretaryTime') {
      //   if (this.list.races[this.selected.raceIndex].statuses.stewardsEnquiryTime) {
      //     errorMessage = '"Steward Enquiry" already selected';
      //     abort = true;
      //   }
      //   if (this.list.races[this.selected.raceIndex].statuses.stewardsSecretaryTime) {
      //     errorMessage = '"Steward Secretary" cannot be reverted';
      //     abort = true;
      //   }
      // }

      if (state === 'resultAmendedTime') {
        if (this.list.races[this.selected.raceIndex].statuses.stewardsEnquiryTime) {
          if (this.list.races[this.selected.raceIndex].statuses.resultStandsTime) {
            errorMessage = '"Result Stands" already selected';
            abort = true;
          }
          if (this.list.races[this.selected.raceIndex].statuses.resultAmendedTime) {
            errorMessage = '"Result Amended" cannot be reverted';
            abort = true;
          }
        } else {
          errorMessage = '"Steward Enquiry" state must have been selected before sending the amended results.';
          abort = true;
        }
      }

      if (state === 'resultStandsTime') {
        if (this.list.races[this.selected.raceIndex].statuses.stewardsEnquiryTime) {
          if (this.list.races[this.selected.raceIndex].statuses.resultAmendedTime) {
            errorMessage = '"Result Amended" already selected';
            abort = true;
          }
          if (this.list.races[this.selected.raceIndex].statuses.resultStandsTime) {
            errorMessage = '"Result Stands" cannot be reverted';
            abort = true;
          }
        } else {
          errorMessage = '"Steward Enquiry" state must have been selected before confirming the previous results.';
          abort = true;
        }
      }

      // Warning for non-reversible states
      if (!abort && (state === 'resultAmendedTime' || state === 'resultStandsTime' || state === 'stewardsEnquiryTime')) {
        if (!this.meta.modalOpen) {
          if (state === 'resultAmendedTime') {
            try {
              const res = await this.apiService.isResultAmended(payload.year, payload.raceId, payload.divSeq).toPromise();
              if (!res.isResultAmended) {
                errorMessage = 'Result has not been amended yet';
                abort = true;
              }
            } catch (err) {
              this.notification.error(`Check your connection and try again.`, 'Is result amended', { disableTimeOut: true });
              abort = true;
            }
          }

          if (!abort) {
            let messageType;
            switch(state) {
              case 'resultAmendedTime':
                messageType = 'the Result has been Amended';
                break;
              case 'resultStandsTime':
                messageType = 'the Result Stands';
                break;
              case 'stewardsEnquiryTime':
                messageType = 'a Stewards Enquiry';
                break;
            }

            const modalWindow = this.modalService.open(ConfirmActionComponent, { backdrop: 'static' });
            this.meta.modalOpen = true;
            modalWindow.componentInstance.body = `
            <p>You are confirming <strong>${messageType}</strong>. This Action cannot be reversed as it sends data directly to the Press Association.</p>
            <p>Please confirm that you want to proceed.</p>`;
            await modalWindow.result.then(
              result => {
                this.meta.modalOpen = false;
              },
              reason => {
                this.meta.modalOpen = false;
                abort = true;
              }
            );
          }
        }
      }

      if (abort) {
        if (errorMessage) {
          this.notification.error(errorMessage, 'State Update');
        }
        this.meta.savingData = false;
        return;
      }

      payload[state] = ts;

      console.log(state, 'saving');
      this.apiService.updateRace(payload.year, payload.raceId, payload.divSeq, payload).subscribe(
        res => {
          // If the WO status is set but there are some jockeys not weighed out, display a warning
          this.list.races[this.selected.raceIndex].statuses[state] = ts;
          if (state === 'weighedOutTime' && this.list.races[this.selected.raceIndex].statuses[state]) {
            if (this.list.races[this.selected.raceIndex].runners
              .filter(r => !r.nonRunnerCode && !r.withdrawnTimestamp)
              .filter(r => !r.weights['O'].weightRecorded).length
            ) {
              this.notification.warning(`Not all jockeys have been weighed out.`, 'Race Weigh-Out', { disableTimeOut: true });
            }
          }
          this.meta.savingData = false;
        },
        err => {
          if (err.error) {
            let errorMsgs = '';
            for (const [key, value] of Object.entries(err.error)) {
              errorMsgs += value + ' ';
            }
            this.notification.error(errorMsgs, 'Race Status');
          } else {
            this.notification.error(`Could't update status. Check your connection and Try again.`, 'Race Status');
          }
          console.error('Error updating race state', err);
          this.meta.savingData = false;
        }
      );
    }
  }

  confirmRace() {
    const raceToUpdate = this.list.races[this.selected.raceIndex];
    const modalWindow = this.modalService.open(RaceConfirmWeighInComponent, { centered: true, backdrop: 'static' });
    this.meta.modalOpen = true;
    modalWindow.componentInstance.race = raceToUpdate;
    modalWindow.result.then(
      result => {
        this.meta.modalOpen = false;
        // console.log('[ DEBUG ] Modal returned value:', result);
        raceToUpdate.raceWeighedInTime = result.raceWeighedInTime;
      },
      reason => {
        this.meta.modalOpen = false;
        // console.log(`[ DEBUG ] Modal dismissed: ${reason}`);
      }
    );
  }

  updateGearCheckStatus(gearChecks: Array<any>): String {
    let status = 'disabled';
    const gears = gearChecks.filter(gc => gc.code !== 'T');
    if (gears && gears.length) {
      const notChecked = gears.filter(gc => gc.checked === null);
      const failedCheck = gears.filter(gc => gc.checked === false);
      const passedChecks = gears.filter(gc => gc.checked === true);
      if (failedCheck.length > 0) {
        status = 'danger';
      }
      if (notChecked.length < gears.length && notChecked.length > 0) {
        status = 'warning';
      }
      if (passedChecks.length === gears.length) {
        status = 'success';
      }
    }
    return status;
  }

  // Return true if the number of Weighted Out runners is equal to the runners (exclude non runners)
  // TODO: Not used until stipes can be a reliable source
  weightInReady(race): Boolean {
    const actualRunners = race.runners.filter(r => r.nonRunnerCode === null);
    if (race.runners.filter(r => r.weights['O'] && r.weights['O'].weightRecorded).length === actualRunners.length) {
      return true;
    } else {
      return false;
    }
  }

  // Return true is there is at least one runner Weighted In
  weightOutComplete(race): Boolean {
    if (race.runners.filter(r => r.weights['I'] && r.weights['I'].weightRecorded).length) {
      return true;
    } else {
      return false;
    }
  }

  // Return true if at least 4 runners (or less if there are less runners) have been Weighted In
  weightInComplete(race): Boolean {
    const weightOutRunners = race.runners.filter(r => r.weights['O'] && r.weights['O'].weightRecorded).length;
    const requiredWeightIn = weightOutRunners < 4 ? weightOutRunners : 4;
    // console.log(weightOutRunners, requiredWeightIn, race.runners.filter(r => r.weights['I'] && r.weights['I'].weightRecorded).length);
    if (!weightOutRunners) {
      return false;
    } else {
      if (race.runners.filter(r => r.weights['I'] && r.weights['I'].weightRecorded).length >= requiredWeightIn) {
        return true;
      } else {
        return false;
      }
    }
  }

  dataChangeFeedback(race, runner) {
    race.glow = true;
    runner.glow = true;
    setTimeout(() => {
      race.glow = false;
      runner.glow = false;
    }, 2000);
  }

  startListener() {
    this.hermesConnection = this.hermes.updates().subscribe(data => {
      console.log('[ DEBUG ] Data from Hermes', data);
      switch (data['type']) {
        case 'groundConditions':
          this.updateGroundConditions(data);
          break;
        case 'finishingPositions':
          this.updateFinishingPosition(data);
          break;
        case 'nonFinisher':
          this.updateDNF(data);
          break;
        case 'nonRunner':
          this.updateNonRunners(data);
          break;
        default:
          console.log('[ DEBUG ] Unexpected Event:', data);
          break;
      }
    });
  }

  private updateGroundConditions(data) {
    if (this.list.fixtures[this.selected.fixtureIndex].fixtureId === data.meta.fixtureId) {
      if (data.data.ground && data.data.ground.value) {
        this.list.fixtures[this.selected.fixtureIndex].conditions.ground = data.data.ground.value;
        this.list.fixtures[this.selected.fixtureIndex].conditions.groundUpdatedAt = data.meta.modifiedTimestamp;
      }
      if (data.data.places && data.data.places.value) {
        this.list.fixtures[this.selected.fixtureIndex].conditions.conditionInPlaces = data.data.places.value;
        this.list.fixtures[this.selected.fixtureIndex].conditions.groundUpdatedAt = data.meta.modifiedTimestamp;
      }
      if (data.data.going && data.data.going.available) {
        this.list.fixtures[this.selected.fixtureIndex].conditions.goingStickAvailable = data.data.going.available;
        this.list.fixtures[this.selected.fixtureIndex].conditions.goingStick = data.data.going.value;
        this.list.fixtures[this.selected.fixtureIndex].conditions.goingStickUpdatedAt = data.data.going.updatedAt;
      }
      this.processFixtures();
      this.notification.info(`The GOING for this fixture has been updated.`, 'GOING', { disableTimeOut: true });
    }
  }

  private updateFinishingPosition(data) {
    // console.log('current fixture', this.list.fixtures[this.selected.fixtureIndex], 'payload', data);
    const raceToUpdate = this.list.races.find(
      race => race.raceId === data.raceId && race.divisionSequence === data.divisionSequence
    );

    if (!raceToUpdate || !(data.runners && data.runners.length)) return;

    data.runners.forEach(updatedRunner => {
      const runnerToUpdate = raceToUpdate.runners.find(
        runner => runner.animalId === Number(updatedRunner.animalId)
      );

      if (!runnerToUpdate) return;

      if (updatedRunner.photoFinish) {
        Object.assign(runnerToUpdate, {
          photoFinish: updatedRunner.photoFinish,
          position: null
        });
      } else {
        const updatedPosition = updatedRunner.rank || updatedRunner.finishingPosition;
        if (runnerToUpdate.position !== updatedPosition) {
          if (updatedPosition >= 1 && updatedPosition <= 4) {
            runnerToUpdate.requiredWeightIn = true;
          }

          Object.assign(runnerToUpdate, {
            position: updatedPosition,
            positionPfo: updatedPosition,
            photoFinish: null
          });
        }
      }

      this.dataChangeFeedback(raceToUpdate, runnerToUpdate);
    });

    this.notification.success(`The ${raceToUpdate.raceTime} Race have received the finishing positions.`, 'Finishing Positions');
  }

  private updateDNF(data) {
    if (this.list.fixtures[this.selected.fixtureIndex].fixtureId === data.fixtureId) {
      const raceToUpdate = this.list.races.find(race => race.raceId === data.raceId && race.divisionSequence === data.divisionSequence);
      if (raceToUpdate) {
        const runnerToUpdate = raceToUpdate.runners.find(runner => runner.animalId === Number(data.animalId));
        if (runnerToUpdate) {
          runnerToUpdate.nonFinishingCode = data.nonFinishingCode;
          runnerToUpdate.nonFinishingDescription = data.nonFinishingCode
            ? this.apiService.getFinishingCodes().find(nf => nf.id === data.nonFinishingCode).label
            : null;
          this.dataChangeFeedback(raceToUpdate, runnerToUpdate);
        }
        this.notification.success(`The ${raceToUpdate.raceTime} Race have received non-finishers.`, 'Non Finishers');
      }
    }
  }

  private updateNonRunners(data) {
    if (this.list.fixtures[this.selected.fixtureIndex].fixtureId === data.fixtureId) {
      const raceToUpdate = this.list.races.find(race => race.raceId === data.raceId && race.divisionSequence === data.divisionSequence);
      if (raceToUpdate) {
        const runnerToUpdate = raceToUpdate.runners.find(runner => runner.animalId === Number(data.animalId));
        if (runnerToUpdate) {
          runnerToUpdate.nonRunnerReason = data.nonRunnerReason;
          runnerToUpdate.nonRunnerTimestamp = data.nonRunnerTimestamp;
          runnerToUpdate.nonRunnerCode = data.nonRunnerCode;
          runnerToUpdate.nonRunnerComment = data.nonRunnerComment;
          this.dataChangeFeedback(raceToUpdate, runnerToUpdate);
        }
        this.notification.success(`${raceToUpdate.raceTime} Race - ${runnerToUpdate.animalName} is now Non Runner`,
          'non Runner', { disableTimeOut: true }
        );
      }
    }
  }

  copyDebugInfo = () => {
    const debugInfo =
      `` +
      `Fixture ID: ${this.list.fixtures[this.selected.fixtureIndex].fixtureId}\n` +
      `Race ID: ${this.list.races[this.selected.raceIndex].raceId}\n` +
      `Division: ${this.list.races[this.selected.raceIndex].divisionSequence}\n`;
    this.clipboardService.copyFromContent(debugInfo);
    this.meta.debugInfoCopied = true;
    setTimeout(() => {
      this.meta.debugInfoCopied = false;
    }, 2000);
  }

  protected isJockeyUnder18(dateOfBirth: string): boolean {
    const now = moment();
    const birthDate = moment(dateOfBirth);

    return now.diff(birthDate, 'years') < 18;
  }

  protected jockeyRoomLeave(): void {
    const race = this.list.races[this.selected.raceIndex];
    const modalWindow = this.modalService.open(JockeyRoomLeaveComponent,
      { centered: true, backdrop: 'static' }
    );
    this.meta.modalOpen = true;
    modalWindow.componentInstance.race = race;
    modalWindow.result.then(
      result => {
        this.meta.modalOpen = false;
        race.leaveWeighRoom = result;
      },
      reason => {
        this.meta.modalOpen = false;
      }
    );
  }
}
